import moment from 'moment'

class MyDateRange {
  constructor(i18n, val, show) {
    this.i18n = i18n
    this.value = val
    this.show = show
  }

  get name() {
    return this.i18n
  }
}
const defaultRanges = [
  new MyDateRange('昨日', [moment().subtract(1, 'd'), moment().subtract(1, 'd')], true),
  new MyDateRange('近七天', [moment().subtract(7, 'd'), moment().subtract(1, 'd')], true),
  new MyDateRange('近15天', [moment().subtract(15, 'd'), moment().subtract(1, 'd')], true),
  new MyDateRange('近30天', [moment().subtract(30, 'd'), moment().subtract(1, 'd')], true),
  new MyDateRange('近90天', [moment().subtract(90, 'd'), moment().subtract(1, 'd')], false),
  new MyDateRange('近180天', [moment().subtract(180, 'd'), moment().subtract(1, 'd')], false),
  new MyDateRange('近3个月', [moment().subtract(3, 'M'), moment().subtract(1, 'd')], false),
  new MyDateRange('近1年', [moment().subtract(1, 'y'), moment().subtract(1, 'd')], false),
  new MyDateRange('最新一周', [moment().subtract(1, 'd').day(1), moment().subtract(1, 'd').day(7)], false),
  new MyDateRange('最新一月', [moment().subtract(1, 'd').startOf('month'), moment().subtract(1, 'd').endOf('month')], false),
  new MyDateRange('全部', [moment(new Date(2017, 3, 14)), moment().subtract(1, 'd')], false),
]
export default defaultRanges
